import React from "react";
import CustomSkeletonTable from "../../../../ui/CustomSkeletonTable/CustomSkeletonTable";
import UserRoleTableTanstack from "../../tables/UserRoleTableTanstack";
import UserEmptyState from "./UserEmptyState";

const UserTableContent = ({
  loadingData,
  noUsers,
  noResults,
  filteredUsers,
  onEdit,
  onToggleStatus,
  loadingIds,
  onManageRoles,
  onUnblockPin,
  isRefetching,
  isSuperAdmin,
  emptyStateMessage,
  emptyStateSubMessage,
}) => {
  if (loadingData) {
    return <CustomSkeletonTable columns={[1, 2, 3, 4, 5]} rowCount={10} />;
  }

  if (noUsers || noResults) {
    return (
      <UserEmptyState
        noUsers={noUsers}
        noResults={noResults}
        emptyStateMessage={emptyStateMessage}
        emptyStateSubMessage={emptyStateSubMessage}
      />
    );
  }

  return (
    <UserRoleTableTanstack
      data={filteredUsers}
      onEdit={onEdit}
      onToggleStatus={onToggleStatus}
      loadingIds={loadingIds}
      onManageRoles={onManageRoles}
      onUnblockPin={onUnblockPin}
      isRefetching={isRefetching}
      isSuperAdmin={isSuperAdmin}
    />
  );
};

export default UserTableContent;
